/**
 * Response envelope shared with Tokki-backend (internal/pkg/response).
 * Keep these types in sync with the backend whenever the envelope changes.
 */

/** How the frontend should present an error. Mirrors `errcode.ShowType` in Tokki-backend. */
export const ShowType = {
  Silent: 0,
  WarnMessage: 1,
  ErrorMessage: 2,
  Notification: 3,
  Redirect: 9,
} as const

export type ShowType = (typeof ShowType)[keyof typeof ShowType]

export interface ApiSuccessResponse<Data> {
  success: true
  data: Data
  requestId?: string
}

export interface ApiPageResponse<Item> {
  success: true
  data: Item[]
  total: number
  current: number
  pageSize: number
  requestId?: string
}

export interface ApiErrorResponse {
  success: false
  errorCode: number
  errorMessage: string
  showType: ShowType
  data?: unknown
  requestId?: string
}

/** Pagination query for list endpoints. Backend defaults: current=1, pageSize=20, max pageSize=100. */
export interface PageQuery {
  current?: number
  pageSize?: number
}

/** Unwrapped list result handed to business code. */
export interface PageResult<Item> {
  items: Item[]
  total: number
  current: number
  pageSize: number
}

export type QueryParams = Record<string, string | number | boolean | null | undefined>

/** Per-request options exposed to business code; axios types never leak outside `services/http`. */
export interface RequestOptions {
  params?: QueryParams
  headers?: Record<string, string>
  signal?: AbortSignal
  timeoutMs?: number
}
